import { CreateMetadataFieldRequest } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LIST_ALL_METADATA_FIELDS_QUERY_KEY } from './useListAllMetadataFields';

export const useCreateMetadataFields = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, isPending, error } = useMutation({
    mutationFn: (data: CreateMetadataFieldRequest) => api.metadata.createMetadataField(tenantId, data),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: [LIST_ALL_METADATA_FIELDS_QUERY_KEY],
        exact: false,
      });
    },
  });

  return {
    createMetadataField: mutate,
    isCreating: isPending,
    createError: getApiError(error),
  };
};
